/**
 * Small inline stroke icons shared across the SPAs. They inherit color via
 * `currentColor` and size to `h-4 w-4`; pass them to `Input`'s `leftIcon` or a
 * `Button`'s `leftIcon`.
 */

export function SearchIcon() {
  return (
    <svg
      className="h-4 w-4"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 20 20"
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.8"
        d="M8.5 14a5.5 5.5 0 1 1 0-11 5.5 5.5 0 0 1 0 11Zm4.4-1.1 3 3"
      />
    </svg>
  );
}

export function PlusIcon() {
  return (
    <svg
      className="h-4 w-4"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 20 20"
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.8"
        d="M10 4.5v11M4.5 10h11"
      />
    </svg>
  );
}
